import gql from 'graphql-tag';


export const UPDATE = gql(`
mutation($data: SearchConfigInputType!){
    searchConfigMutation{
        updateSearchConfig(data:$data)
        {            
            userId
            applicationId
            applicationVersion
            componentId
            profileId
            name
            data
            fcr
        }
    }
}
`);

export const ADD = gql(`
mutation($data: SearchConfigInputType!){
    searchConfigMutation{
        addSearchConfig(data:$data)
        {            
            userId
            applicationId
            applicationVersion
            componentId
            profileId
            name
            data
            fcr
        }
    }
}
`);

export const DELETE = gql(`
mutation($userId: Int!,$applicationId: Int!,$applicationVersion: Int!,$componentId: Int!,$name:String! ){
    searchConfigMutation{
        deleteSearchConfig(userId: $userId, applicationId: $applicationId, applicationVersion: $applicationVersion, componentId: $componentId, name: $name)
    }
}
`);





